import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row, Typography } from 'antd';
import { AssignmentStateMenu } from 'works/components/assignment-state-menu';
import { ExpiredComplianceItemsCount } from 'works/components/expired-compliance-items-count';
import { ExtensionOfferState } from 'works/components/extension-offer-state/extension-offer-state';
import CandidateAssignmentContact from './candidate-assignment-contact';
import { TimeWithTimeZone } from '@common/components';
import {
  AssignmentCancelReason,
  AssignmentOnboardingDueDate,
} from '@working-experience/components';

const { Title } = Typography;

export function CandidateAssignmentHeader({ assignment }) {
  const worksListId = assignment?.worksList?.id;
  const state = assignment?.state;

  return (
    <section className="AssignmentHeader">
      <Row align="middle" gutter={[8, 0]} style={{ marginBottom: 16 }}>
        <Col>
          <Title className="sentry-mask" level={3} style={{ marginBottom: 0 }}>
            {assignment.worksProfile.fullName}
          </Title>
        </Col>

        <Col>
          <AssignmentStateMenu assignment={assignment} />
        </Col>

        {(assignment.activeExtensionOffer || assignment.extensionCount > 0) && (
          <Col>
            <ExtensionOfferState
              assignment={assignment}
              offer={assignment.activeExtensionOffer}
              extensionCount={assignment.extensionCount}
            />
          </Col>
        )}

        {state !== 'cancelled' && state !== 'completed' && (
          <Col>
            <ExpiredComplianceItemsCount assignment={assignment} />
          </Col>
        )}

        {['onboarding', 'cleared'].includes(state) && (
          <Col>
            <AssignmentOnboardingDueDate worksListId={worksListId} />
          </Col>
        )}

        {state === 'cancelled' && (
          <>
            <Col>
              <AssignmentCancelReason
                reasonName={assignment.cancelledReason}
                details={assignment.cancelledDetail}
              />
            </Col>
            <Col>
              <TimeWithTimeZone
                date={assignment.stateChangedAt}
                variant="verbose_shorter"
              />
            </Col>
          </>
        )}
      </Row>

      <CandidateAssignmentContact assignment={assignment} />

      <style jsx>{`
        .AssignmentHeader {
          padding-bottom: 36px;
        }
        .AssignmentHeader strong {
          font-weight: 600;
        }
      `}</style>
    </section>
  );
}

CandidateAssignmentHeader.propTypes = {
  assignment: PropTypes.shape({
    id: PropTypes.string.isRequired,
    state: PropTypes.string.isRequired,
    stateChangedAt: PropTypes.string.isRequired,
    cancelledReason: PropTypes.string,
    cancelledDetail: PropTypes.string,
    extensionCount: PropTypes.number,
    activeExtensionOffer: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }),
    worksList: PropTypes.shape({
      id: PropTypes.string,
      worksListTemplate: PropTypes.shape({
        complianceDeadlineDetails: PropTypes.string,
      }),
    }),
    worksProfile: PropTypes.shape({
      id: PropTypes.string.isRequired,
      fullName: PropTypes.string.isRequired,
    }),
  }),
};
